  

<template>
  <div :class="`phone-details ${isMobile ? 'mobile' : ''}`">
    <button
      v-if="!detailsPressed && !selectedPressed"
      class="outer-ui close-btn btn"
      @click="$emit('closeui')"
      style="text-align: right"
    >
      <img
        src="https://media.in3d-store.com/media/icons/close dark 72.svg"
        alt
        style="text-align: right"
      />
    </button>

    <div class="wrap">
      <carousel-3d
        :width="!isMobile ? 375 : 313"
        :space="!isMobile ? 400 : 355"
        :minSwipeDistance="ifOrbiting"
        class="carousel"
      >
        <slide :index="0">
          <div class="init-swipe-hand" v-if="isMobile && startCardSwipeAnim">
            <p>Swipe screen to find out more</p>

            <img
              src="https://media.in3d-store.com/media/icons/card-swipe-flipped.svg"
              alt=""
              class="right"
            />
          </div>

          <div class="inner-wrap">
            <h2 class="phone-name">{{ currentModel.name }}</h2>
            <h3 class="card-name">Want to explore?</h3>
            <!-- {{stockCheck()}} -->
            <h3 class="out-of-stock" v-if="!stockCheck()">
              OUT OF STOCK ONLINE
            </h3>

            <img
              class="init360"
              src="/icons/360.svg"
              v-if="!isMobile && is360"
              alt="360"
            />

            <model-viewer
              style="outline: 0"
              v-if="isMobile"
              @touchstart="ifOrbiting = 34634646364"
              @touchend="ifOrbiting = 40"
              @mousedown="ifOrbiting = 434636346346"
              @mouseup="ifOrbiting = 10"
              @mouseleave="ifOrbiting = 10"
              interaction-prompt-threshold="0"
              :interaction-prompt="colorInitChange"
              :src="`/phones/${currentModel.name.replace(/ /g, '_')}${
                currentModel.name === 'iPhone 11' ||
                currentModel.name === 'iPhone 11 Pro Max'
                  ? '/hi_poly/Saturated/'
                  : '/hi_poly/'
              }${currentModel.current.color}.glb`"
              :exposure="MVexposure(currentModel.name)"
              @load="(phoneLoaded = true), modelViewerLoaded()"
              @error="$emit('oopsie')"
              class="orbit sceneMobile"
              alt="A 3D model of a phone"
              camera-controls
              ><div class="loader" v-if="!phoneLoaded"></div
            ></model-viewer>

            <a-scene
              v-else
              class="orbit scenePc"
              embedded
              @touchstart="ifOrbiting = 34634646364"
              @touchend="ifOrbiting = 40"
              @mousedown="ifOrbiting = 434636346346"
              @mouseup="ifOrbiting = 10"
              @mouseleave="ifOrbiting = 10"
              vr-mode-ui="enabled: false"
              initialPosition="10 0 10"
              enablePan="false"
              enableZoom="false"
              device-orientation-permission-ui="enabled: false"
            >
              <div class="loader" v-if="!phoneLoaded"></div>
              <a-entity v-if="currentModel.name === 'iPhone 11'">
                <a-entity
                  light="type: ambient; color: #BBB; intensity: 1.3"
                ></a-entity>
                <a-entity
                  light="type: directional; color: #FFF; intensity: 0.6"
                  position="-0.5 1 1"
                ></a-entity>
              </a-entity>
              <!-- <a-entity v-if="currentModel.name === 'iPhone 11 Pro Max'">
                <a-entity
                  light="type: ambient; color: #BBB; intensity: 1.34; "
                ></a-entity>

                <a-entity
                  light="type: directional; color: #FFF; intensity: 0.6"
                  position="-0.5 1 1"
                ></a-entity>
              </a-entity> -->

              <a-entity
                :orbit-controls="'target: 0 1.6 -0.5; minDistance: 13; maxDistance: 15; initialPosition: 0 0 15; enablePan: false;'"
              ></a-entity>
              <a-entity
                :gltf-model="`/phones/${currentModel.name.replace(
                  / /g,
                  '_'
                )}/hi_poly/${currentModel.current.color}.glb`"
                class="colorTest rayClick"
                :scale="phoneScale(currentModel.name)"
                rotation="0 0 0"
                :position="phonePosition(currentModel.name)"
                @model-loaded="(phoneLoaded = true), show360()"
              >
              </a-entity>
            </a-scene>
            <!-- <div class="orbit-view"></div> -->
            <div
              class="selection-wrap"
              @touchstart="ifOrbiting = 34634646364"
              @touchend="ifOrbiting = 40"
            >
              <div class="colors">
                <button
                  style
                  :class="`circle-color ${
                    currentModel.current.color === color.color ? 'check' : ''
                  } ${
                    currentModel.current.color === color.color &&
                    currentModel.current.color === 'White'
                      ? 'white'
                      : ''
                  }`"
                  v-for="(color, index) in currentModel.other"
                  :key="index"
                  :title="color.color"
                  :style="`background-color: ` + color.colorHex"
                  @click="colorClick(color, index), (colorInitChange = true)"
                >
                  <!-- <img
                    src="/icons/check.svg"
                    v-if="currentModel.current.color === color.color"
                    class="check"
                  /> -->
                </button>
                <!-- <div style="position: absolute; color white" v-if="currentModel.color === color">asf</div> -->
              </div>
              <div class="memory">
                <button
                  v-for="(selection, index) in currentModel.memory"
                  @click="selectedMemory = selection"
                  :class="`btn-memory btn btn-shape ${
                    selectedMemory === selection ? 'selected' : ''
                  }`"
                  :key="index"
                >
                  {{ selection }}
                </button>
              </div>
            </div>
            <!-- <img class="floating-globe" src="/icons/globe.svg" alt /> -->
            <!-- <div class="device-only-wrap">
              <button class="device-only btn">Buy Device Only</button>
            </div>-->
          </div>
        </slide>

        <slide :index="1">
          <div class="inner-wrap" style="height: unset">
            <h2 class="the-plan-txt">
              <span class="left-wrap">
                <span class="choose">CHOOSE</span>
                <span class="light your">Your</span>
              </span>
              <span class="heavy plan">PLAN</span>
            </h2>
            <div class="tags-details-wrap">
              <div class="plans-tags">
                <div v-for="(plan, index) in plans" :key="index">
                  <div class="tag" :class="`plan${index}`">
                    <!-- <img src="/img/plan.png" alt /> -->
                    <span class="price heavy">{{ plan.price }}</span>
                  </div>
                </div>
                <!-- 
              <span class="heavy">{{currentPlan}}</span>
              <span class="heavy">{{plans.length}}</span>-->
              </div>
              <div class="details-slide">
                <button class="toggle-plan btn" @click="slide('left')">
                  <
                </button>
                <button
                  class="view-details btn-spec"
                  @click="detailsPressed = true"
                >
                  View details
                </button>

                <button class="toggle-plan btn" @click="slide('right')">
                  >
                </button>
              </div>
              <div class="big-btn-wrap">
                <button
                  @click="selectedPressed = true"
                  :class="`select-btn btn ${!stockCheck() ? 'disabled' : ''}`"
                  :disabled="!stockCheck()"
                >
                  <!-- :title="!stockCheck() ? 'OUT OF STOCK' : ''" -->
                  <div class="hover-effect-big-btn" v-if="stockCheck()"></div>
                  Select
                </button>
              </div>
            </div>
          </div>
        </slide>

        <slide :index="2">
          <div class="inner-wrap">
            <h2 class="phone-name">{{ currentModel.name }}</h2>
            <h3 class="card-name">Features & Specifications</h3>

            <div class="btn-wrap">
              <button
                :class="`btn-spec ${featured ? 'selected' : ''}`"
                @click="featured = true"
              >
                Features
              </button>
              <button
                :class="`btn-spec ${!featured ? 'selected' : ''}`"
                @click="featured = false"
              >
                Specification
              </button>
            </div>

            <div class="specs-wrap">
              <span
                v-for="(spec, index) in featured
                  ? currentModel.specifications.feats
                  : currentModel.specifications.specs"
                :key="index"
              >
                <div
                  :class="`spec `"
                  v-if="ifShowSpec(spec, currentModel.name)"
                >
                  <span>
                    <div class="inner-wrap">
                      <div class="icon-wrap">
                        <img
                          v-if="
                            spec.title === 'CAMERA' ||
                            spec.title === 'REAR CAMERA' ||
                            spec.title === 'PRIMARY CAMERA' ||
                            spec.title === 'VIDEO'
                          "
                          :class="'icon camera'"
                          :src="`/icons/camera.svg`"
                          alt="icon"
                        />
                        <img
                          v-else-if="
                            (spec.title.includes('DISPLAY') && !featured) ||
                            spec.title === 'DISPLAY SIZE'
                          "
                          :class="'icon screen'"
                          :src="`/icons/spec_display.svg`"
                          alt="icon"
                        />
                        <img
                          v-else-if="spec.title.includes('BATTERY')"
                          :class="'icon battery'"
                          :src="`/icons/battery.svg`"
                          alt="icon"
                        />
                        <img
                          v-else-if="spec.title.includes('OS') && !featured"
                          :class="`icon screen ${currentModel.os}`"
                          :src="`/icons/${currentModel.os}.svg`"
                          alt="icon"
                        />
                        <img
                          v-else
                          :class="'icon ' + spec.title.toLowerCase()"
                          :src="`/icons/${spec.title.toLowerCase()}.svg`"
                          alt="icon"
                        />
                      </div>
                      <div class="txt-wrap">
                        <p
                          class="main-txt"
                          v-if="
                            spec.title === 'CAMERA' ||
                            spec.title === 'REAR CAMERA' ||
                            spec.title === 'PRIMARY CAMERA' ||
                            spec.title === 'VIDEO'
                          "
                        >
                          CAMERA
                        </p>
                        <p
                          class="main-txt"
                          v-else-if="
                            (spec.title.includes('DISPLAY') && !featured) ||
                            spec.title === 'DISPLAY SIZE'
                          "
                        >
                          SCREEN SIZE
                        </p>
                        <p
                          class="main-txt"
                          v-else-if="spec.title.includes('BATTERY') && featured"
                        >
                          BATTERY
                        </p>
                        <p v-else class="main-txt">{{ spec.title }}</p>
                        <p class="sub-txt">
                          {{
                            spec.description.charAt(0).toUpperCase() +
                            spec.description.slice(1).replace(/\?/g, "-")
                          }}
                        </p>
                        <!-- changes first letter of every string in description to toUpperCase -->
                      </div>
                    </div>
                  </span>
                </div>
              </span>
              <div v-if="featured" class="spec no-border">
                <span>
                  <div class="inner-wrap">
                    <div class="icon-wrap">
                      <img
                        :class="'icon memory'"
                        :src="`/icons/memory.svg`"
                        alt="icon"
                      />
                    </div>
                    <div class="txt-wrap">
                      <p class="main-txt">MEMORY</p>
                      <p class="sub-txt">
                        {{
                          selectedMemory === "None selected"
                            ? currentModel.memory[0]
                            : selectedMemory
                        }}
                      </p>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </slide>
      </carousel-3d>

      <div :class="`selected-details`" v-if="selectedPressed">
        <button class="outer-ui close-btn btn" @click="selectedPressed = false">
          <img src="/icons/close dark 72.svg" alt />
        </button>
        <div class="inner-wrap">
          <h1 class="header-txt">You have selected</h1>
          <div class="details-wrap">
            <div class="detail-wrap">
              <span class="icon-wrap">
                <img :src="`/icons/mobile_white.svg`" alt />
              </span>
              <p><span class="name">Device</span> {{ currentModel.name }}</p>
            </div>

            <div class="detail-wrap">
              <span class="icon-wrap">
                <button
                  :class="`circle-color`"
                  :style="`background-color: ${
                    currentModel.other.find(
                      ({ color }) => color === currentModel.current.color
                    ).colorHex
                  }`"
                ></button>
              </span>
              <p>
                <span class="name">Color</span> {{ currentModel.current.color }}
              </p>
            </div>
            <div class="detail-wrap">
              <span class="icon-wrap">
                <img :src="`/icons/memory_white.svg`" alt />
              </span>
              <p><span class="name">Storage</span> {{ selectedMemory }}</p>
            </div>
            <div class="detail-wrap">
              <span class="icon-wrap plan">
                <img
                  :src="`https://media.in3d-store.com/media/icons/plan_selected.png`"
                  alt
                />
              </span>
              <p>
                <span class="name">ThePLAN</span>
                {{ plans[currentPlan].price }}
              </p>
            </div>
          </div>
          <div class="nextstep-btns">
            <a
              :href="`${linkSet(currentModel).link}?option=${
                linkSet(currentModel).num
              }:${
                selectedMemory === 'None selected'
                  ? (selectedMemory = currentModel.memory[0])
                  : selectedMemory.match(/[0-9]+/g)[0]
              }&planID=${plans[currentPlan].id}`"
              target="_"
              ><button class="btn btn-spec">Continue to purchase</button></a
            >
            <button class="btn btn-spec" @click="selectedPressed = false">
              Continue browsing
            </button>
          </div>
        </div>
      </div>
      <div :class="`selected-details-mobile`" v-if="selectedPressed">
        <button class="outer-ui close-btn btn" @click="selectedPressed = false">
          <img
            src="https://media.in3d-store.com/media/icons/close dark 72.svg"
            alt
          />
        </button>
        <img
          src="https://media.in3d-store.com/media/img/selectedMan.png"
          alt=""
        />

        <div class="inner-wrap">
          <div class="details-wrap">
            <div class="detail-wrap">
              <span class="icon-wrap">
                <img :src="`/icons/mobile_white.svg`" alt />
              </span>
              <p><span class="name">Device</span> {{ currentModel.name }}</p>
            </div>
            <div class="detail-wrap">
              <span class="icon-wrap">
                <img :src="`/icons/memory_white.svg`" alt />
              </span>
              <p><span class="name">Storage</span> {{ selectedMemory }}</p>
            </div>
            <div class="detail-wrap">
              <span class="icon-wrap">
                <button
                  :class="`circle-color`"
                  :style="`background-color: ${
                    currentModel.other.find(
                      ({ color }) => color === currentModel.current.color
                    ).colorHex
                  }`"
                ></button>
              </span>
              <p>
                <span class="name">Color</span> {{ currentModel.current.color }}
              </p>
            </div>
            <div class="detail-wrap">
              <span class="icon-wrap plan">
                <img
                  :src="`https://media.in3d-store.com/media/icons/plan_selected.png`"
                  alt
                />
              </span>

              <p>
                <span class="name">ThePLAN</span> {{ plans[currentPlan].price }}
              </p>
            </div>
          </div>

          <div class="nextstep-btns">
            <a
              :href="`${linkSet(currentModel).link}?option=${
                linkSet(currentModel).num
              }:${
                selectedMemory === 'None selected'
                  ? (selectedMemory = currentModel.memory[0])
                  : selectedMemory.match(/[0-9]+/g)[0]
              }&planID=${plans[currentPlan].id}`"
              target="_"
              ><button class="btn btn-spec">Continue to purchase</button></a
            >
            <button class="btn btn-spec" @click="selectedPressed = false">
              Continue browsing
            </button>
          </div>
        </div>
      </div>
      <div :class="`plan-details`" v-if="detailsPressed && !isMobile">
        <button class="outer-ui close-btn btn" @click="detailsPressed = false">
          <img src="/icons/close dark 72.svg" alt />
        </button>
        <div class="inner-wrap">
          <h1 class="plan-logo"><span class="light">The</span>Plan</h1>
          <div class="details-wrap">
            <span
              v-for="(detail, i) in plans[currentPlan].planDetails"
              :key="i"
            >
              <div class="detail-wrap">
                <span class="icon-wrap">
                  <img :src="`/icons/${detail.icon}.svg`" alt />
                </span>
                <p>{{ detail.text }}</p>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div :class="`plan-details-mobile`" v-if="detailsPressed & isMobile">
        <button class="outer-ui close-btn btn" @click="detailsPressed = false">
          <img
            src="https://media.in3d-store.com/media/icons/close dark 72.svg"
            alt
          />
        </button>
        <img
          class="mobile-vd-img"
          src="https://media.in3d-store.com/media/img/popup view details.png"
          alt=""
        />
        <div class="details-wrap">
          <span v-for="(detail, j) in plans[currentPlan].planDetails" :key="j">
            <div class="detail-wrap">
              <span class="icon-wrap">
                <img
                  :src="`https://media.in3d-store.com/media/icons/${detail.icon}.svg`"
                  alt
                />
              </span>
              <p>{{ detail.text }}</p>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable */
export default {
  name: "phone-details",
  components: {},
  props: ["selectedPhone", "isFullScreen", "inStockArray"],
  computed: {
    currentModel: function () {
      // console.log(this.currentModel.current.color);
      let selected = this.selectedPhone;
      // console.log(selected.name);
      // console.log(selected.other);
      if (selected.name === "iPhone 11") {
        for (let i = 0; i < selected.other.length; i++) {
          const phone = selected.other[i];
          let hex;
          if (phone.color === "Green") phone.colorHex = "#84cfce";
          else if (phone.color === "Yellow") phone.colorHex = "#e3e2a1";
          else if (phone.color === "Purple") phone.colorHex = "#9da3bc";
          else if (phone.color === "Red") phone.colorHex = "#97001a";
        }
      }
      if (selected.name === "iPhone 11 Pro Max") {
        for (let i = 0; i < selected.other.length; i++) {
          const phone = selected.other[i];
          let hex;
          if (phone.color === "Green") phone.colorHex = "#383f3a";
          else if (phone.color === "Gold") phone.colorHex = "#bb7e57";
          else if (phone.color === "Silver") phone.colorHex = "#919081";
          else if (phone.color === "Space Gray") phone.colorHex = "#3b3a39";
        }
      }
      return selected;
    },
  },

  data: function () {
    return {
      exposure: 0.7,
      shadowIntensity: 0,
      shadowSoftness: 1,
      is360: false,
      happenOnce360: false,
      phoneLoaded: false,
      colorInitChange: false,
      selectedPressed: false,
      ifOrbiting: 10,
      animFrame: 1,
      specifications: [],
      startCardSwipeAnim: false,
      // currentModel: this.selectedPhone,
      selectedMemory: "None selected",
      featured: true,
      detailsPressed: false,
      plans: [
        {
          price: 599,
          id: 961755016,
          planDetails: [
            { icon: "wifi", text: "2GB mobile internet" },
            { icon: "mail", text: "Unli Texts to Globe/TM" },
            { icon: "phone", text: "Unli Calls to Globe/TM" },
            // { icon: "truck", text: "Free Shipping" },
            // { icon: "shield", text: "Protect your device with Gadget Care" },
            {
              icon: "fb",
              text:
                "Free Facebook (1GB data allocation per month for 24 months)",
            },
          ],
        },
        {
          price: 799,
          id: 961855016,
          planDetails: [
            { icon: "wifi", text: "3GB mobile internet" },
            { icon: "mail", text: "Unli All-Net Text" },
            { icon: "phone", text: "Unli Calls to Globe/TM" },
            { icon: "phone", text: "50 Mins. All-Net Calls" },
            // { icon: "truck", text: "Free Shipping" },
            // { icon: "shield", text: "Protect your device with Gadget Care" },
            {
              icon: "fb",
              text:
                "Free Facebook (1GB data allocation per month for 24 months)",
            },
          ],
        },
        {
          price: 999,
          id: 962055016,
          planDetails: [
            { icon: "wifi", text: "5GB mobile internet" },
            {
              icon: "tv",
              text:
                "Free Amazon Prime Video (6-months subscription, no data included)",
            },
            {
              icon: "tv",
              text: "Free iflixVIP (3-months subscription, no data included)",
            },
            {
              icon: "fb",
              text:
                "Free Facebook (1GB data allocation per month for 24 months)",
            },
            { icon: "mail", text: "Unli All-Net Text" },
            { icon: "phone", text: "Unli Calls to Globe/TM" },
            { icon: "phone", text: "50 Mins. All-Net Calls" },
            // { icon: "truck", text: "Free Shipping" },
            // { icon: "shield", text: "Protect your device with Gadget Care" },
          ],
        },
        {
          price: 1299,
          id: 13350296,
          planDetails: [
            { icon: "wifi", text: "8GB mobile internet" },
            {
              icon: "tv",
              text:
                "Free Amazon Prime Video (6-months subscription, no data included)",
            },
            {
              icon: "tv",
              text: "Free iflixVIP (3-months subscription, no data included)",
            },
            {
              icon: "fb",
              text:
                "Free Facebook (1GB data allocation per month for 24 months)",
            },
            { icon: "mail", text: "Unli All-Net Text" },
            { icon: "phone", text: "Unli Calls to Globe/TM" },
            { icon: "phone", text: "50 Mins. All-Net Calls" },
          ],
        },
        {
          price: 1499,
          id: 13354006,
          planDetails: [
            { icon: "wifi", text: "10GB mobile internet" },
            {
              icon: "tv",
              text:
                "Free Amazon Prime Video (6-months subscription, no data included)",
            },
            {
              icon: "tv",
              text: "Free iflixVIP (3-months subscription, no data included)",
            },
            {
              icon: "fb",
              text:
                "Free Facebook (1GB data allocation per month for 24 months)",
            },
            { icon: "mail", text: "Unli All-Net Text" },
            { icon: "phone", text: "Unli Calls to Globe/TM" },
            { icon: "phone", text: "100 Mins. All-Net Calls" },
          ],
        },
        {
          price: 1799,
          id: 13354026,
          planDetails: [
            { icon: "wifi", text: "15GB mobile internet" },
            {
              icon: "tv",
              text:
                "Free Amazon Prime Video (6-months subscription, no data included)",
            },
            {
              icon: "tv",
              text: "Free iflixVIP (3-months subscription, no data included)",
            },
            {
              icon: "fb",
              text:
                "Free Facebook (1GB data allocation per month for 24 months)",
            },
            { icon: "mail", text: "Unli All-Net Text" },
            { icon: "phone", text: "Unli Calls to Globe/TM" },
            { icon: "phone", text: "100 Mins. All-Net Calls" },
          ],
        },
        {
          price: 1999,
          id: 13353976,
          planDetails: [
            { icon: "wifi", text: "16GB mobile internet" },
            {
              icon: "tv",
              text:
                "Free Amazon Prime Video (6-months subscription, no data included)",
            },
            {
              icon: "tv",
              text: "Free iflixVIP (3-months subscription, no data included)",
            },
            {
              icon: "fb",
              text:
                "Free Facebook (1GB data allocation per month for 24 months)",
            },
            { icon: "mail", text: "Unli All-Net Text" },
            { icon: "phone", text: "Unli Calls to Globe/TM" },
            { icon: "phone", text: "150 Mins. All-Net Calls" },
          ],
        },
        {
          price: 2499,
          id: 13350106,
          planDetails: [
            { icon: "wifi", text: "21GB mobile internet" },
            {
              icon: "tv",
              text:
                "Free Amazon Prime Video (6-months subscription, no data included)",
            },
            {
              icon: "tv",
              text: "Free iflixVIP (3-months subscription, no data included)",
            },
            {
              icon: "fb",
              text:
                "Free Facebook (1GB data allocation per month for 24 months)",
            },
            { icon: "mail", text: "Unli All-Net Text" },
            { icon: "phone", text: "Unli Calls to Globe/TM" },
            { icon: "phone", text: "150 Mins. All-Net Calls" },
          ],
        },
        {
          price: 2999,
          id: 13350086,
          planDetails: [
            { icon: "wifi", text: "31GB mobile internet" },
            {
              icon: "tv",
              text:
                "Free Amazon Prime Video (6-months subscription, no data included)",
            },
            {
              icon: "tv",
              text: "Free iflixVIP (3-months subscription, no data included)",
            },
            {
              icon: "fb",
              text:
                "Free Facebook (1GB data allocation per month for 24 months)",
            },
            { icon: "mail", text: "Unli All-Net Text" },
            { icon: "phone", text: "Unli Calls to Globe/TM" },
            { icon: "phone", text: "300 Mins. All-Net Calls" },
          ],
        },
      ],
      currentPlan: 0,
      isMobile: false,
      // memory: samsungGalaxyA51.product.variants.color[0].intenal_memory,
    };
  },
  methods: {
    modelViewerLoaded: function () {
      // console.log(document.querySelector('model-viewer').shadowRoot.childNodes[3].querySelector('.userInput').style = "outline: 0");
      document
        .querySelector("model-viewer")
        .shadowRoot.childNodes[3].querySelector(".userInput").style =
        "outline: 0";
      // console.log(document.querySelector('model-viewer').shadowRoot.childNodes[3].querySelector('.userInput').childNodes);
    },
    stockCheck: function () {
      let currMem =
        this.selectedMemory === "None selected"
          ? (this.selectedMemory = this.currentModel.memory[0])
          : this.selectedMemory.match(/[0-9]+/g)[0];

      let isInStockArr = this.inStockArray.find(
        ({ color, memory, name }) =>
          name === this.currentModel.name &&
          memory === currMem &&
          color === this.currentModel.current.color
      );
      return isInStockArr === undefined ? false : isInStockArr.isInStock;
    },
    show360: function () {
      if (!this.happenOnce360) {
        this.happenOnce360 = true;
        this.is360 = true;

        this.end360 = setTimeout(
          function () {
            this.is360 = false;
          }.bind(this),
          2000
        );
      }
    },
    colorClick: function (color, index) {
      if (this.currentModel.current.color !== color.color) {
        this.phoneLoaded = false;
        this.currentModel.current.color = color.color;
        this.currentModel.current.colorHex = color.colorHex;
        this.currentModel.memory = color.memory;
        this.currentModel.chosenIndex = index;
      }
    },
    pickerHex: function (model) {
      let name = model.name;
      let color = model.current.color;
      let hex;
      // console.log(name);
      // console.log(color);
      if (name === "iPhone 11") {
        if (color === "Green") hex = "#9ba4a3";
        else if (color === "Yellow") hex = "#9e9e91";
        else {
          model.other.find(({ color }) => color === model.current.color)
            .colorHex;
        }
      } else {
        model.other.find(({ color }) => color === model.current.color).colorHex;
      }

      return hex;
    },
    modelLoaded: function (ev) {
      console.log(ev);
    },
    MVexposure: function (name) {
      let exposure;
      if (name === "iPhone 11 Pro Max") {
        exposure = 1.2;
      } else if (name === "iPhone 11") {
        exposure = 0.7;
      } else {
        exposure = 0.4;
      }
      return exposure;
    },
    ifShowSpec: function (spec, modelName) {
      let show;

      if (spec.title === "INTERNAL MEMORY") show = false;
      else if (spec.title === "EXT MEMORY") show = false;
      else if (spec.title === "EXTERNAL MEMORY") show = false;
      else if (spec.title === "SECONDARY CAMERA") show = false;
      else if (spec.title === "OPERATING SYSTEM") show = false;
      else if (spec.title === "PIXEL/ RESOLUTION") show = false;
      else if (spec.title === "BLUETOOTH") show = false;
      else if (spec.title === "CPU") show = false;
      else if (spec.title === "GPU") show = false;
      else if (spec.title === "RAM" && spec.description === "-") show = false;
      else {
        show = true;
      }

      return show;
    },
    phoneScale: function (name) {
      let scale;
      if (name === "Huawei Nova 5T") {
        scale = "0.06 0.06 0.06";
      }
      if (name === "Huawei Mate 30 Pro") scale = "2.5 2.5 2.5";
      if (name === "Huawei Y9 Prime 2019") scale = "0.11 0.11 0.11";
      if (name === "Samsung Galaxy A51") scale = "0.43 0.43 0.43";
      if (name === "Samsung Galaxy A20s") scale = "0.8 0.8 0.8";
      if (name === "iPhone 11 Pro Max") scale = "12 12 12";
      if (name === "iPhone 11") scale = "3 3 3";
      if (name === "iPhone 6s") scale = "1.4 1.4 1.4";
      if (name === "Oppo A9 2020") scale = "1 1 1";
      if (name === "OPPO A5s") scale = "1 1 1";
      return scale;
    },
    linkSet: function (model) {
      let num;
      let nameInLink = `https://www.globe.com.ph/shop/products/mobile/${model.name
        .replace(/ /g, "-")
        .toLowerCase()}.html`;
      let name = model.name;
      let color = model.current.color;

      if (name === "Huawei Nova 5T") {
        if (color === "Blue") num = "1";
        if (color === "Black") num = "2";
        if (color === "Violet") num = "4";
      }
      if (name === "Huawei Mate 30 Pro") {
        if (color === "Black") num = "1";
        if (color === "Silver") num = "2";
      }
      if (name === "Huawei Y9 Prime 2019") {
        if (color === "Sapphire Blue") num = "1";
        if (color === "	Emerald Green") num = "2";
        if (color === "Midnight Black") num = "3";
      }
      if (name === "Samsung Galaxy A51") {
        if (color === "Blue") num = "1";
        if (color === "Black") num = "2";
      }
      if (name === "Samsung Galaxy A20s") {
        if (color === "Black") num = "1";
        if (color === "Green") num = "2";
      }
      if (name === "iPhone 11 Pro Max") {
        if (color === "Gold") num = "1";
        if (color === "Silver") num = "2";
        if (color === "Space Gray") num = "3";
        if (color === "Green") num = "4";
        nameInLink =
          "https://www.globe.com.ph/shop/products/mobile/apple-iphone-11-pro-max.html";
      }
      if (name === "iPhone 11") {
        if (color === "Black") num = "1";
        if (color === "Red") num = "2";
        if (color === "Yellow") num = "3";
        if (color === "Purple") num = "4";
        if (color === "Green") num = "5";
        if (color === "White") num = "6";
        nameInLink =
          "https://www.globe.com.ph/shop/products/mobile/apple-iphone-11.html";
      }
      if (name === "iPhone 6s") {
        if (color === "Space Gray") num = "806";
        if (color === "Rose Gold") num = "807";
        if (color === "Gold") num = "808";
        if (color === "Silver") num = "903";

        nameInLink =
          "https://www.globe.com.ph/shop/products/mobile/iphone-6s-whitebox.html";
        // if (color === "Space Gray") {
        //   // for staging tests
        // } else {
        //   nameInLink =
        //     "https://www.globe.com.ph/shop/products/mobile/iphone-6s.html";
        // }
      }
      if (name === "Oppo A9 2020") {
        if (color === "Marine Green") num = "1";
        if (color === "Purple") num = "2";
      }
      if (name === "OPPO A5s") {
        if (color === "Blue") num = "1";
        if (color === "Black") num = "2";
        if (color === "Red") num = "3";
      }
      return { num: num, link: nameInLink };
    },
    phonePosition: function (name) {
      let position;
      // console.log(name);
      if (name === "Oppo A9 2020") position = "0 -5 0";
      else if (name === "OPPO A5s") position = "0 -5 0";
      else position = "0 1.5 0";
      return position;
    },
    slide: function (dir) {
      if (dir === "left" && this.currentPlan === 0) {
        this.currentPlan = this.plans.length;
      }
      if (dir === "right" && this.currentPlan > this.plans.length - 2) {
        this.currentPlan = -1;
      }
      let tags = document.querySelector(".plans-tags");
      let direction = dir === "right" ? 1 : -1;
      let widthToScroll = direction * (tags.scrollWidth / this.plans.length);
      // tags.scrollBy({
      //   top: 0, // could be negative value
      //   left: widthToScroll,
      //   behavior: "smooth",
      // });
      dir === "right" ? this.currentPlan++ : this.currentPlan--;
      document.querySelector(`.plan${this.currentPlan}`).scrollIntoView({
        behavior: "smooth",
      });
    },
  },
  created: function () {},
  mounted: function () {
    let scene;
    if (AFRAME.utils.device.isMobile()) {
      this.isMobile = true;
      this.ifOrbiting = 40;

      // let carousel = document.querySelector(".carousel");
      // console.log(carousel);
      // console.log(carousel.getAttribute("autoplay"));
      // :autoplay="true" :autoplay-timeout="2000"
      // style="transform: scale(0.6); overflow: unset;"

      // this.carouselAutoplay.style = "transform: scale(0.5); overflow: unset;";
      this.carouselEndAnim = setTimeout(
        function () {
          // this.carouselAutoplay.time = 23423425;
          // this.carouselAutoplay.isTurning = true;
          // this.carouselAutoplay.style = "";
          this.startCardSwipeAnim = true;
        }.bind(this),
        3000
      );
      this.carouselEndAnim = setTimeout(
        function () {
          this.startCardSwipeAnim = false;
        }.bind(this),
        9000
      );
    }
  },
};
</script>

<style scoped lang="scss">
p {
  margin: 0;
}

model-viewer {
  --poster-color: transparent;
  --progress-color: transparent;
  --progress-mask: transparent;
  --progress-bar-height: transparent;
  &:focus {
    outline: none !important;
    outline-width: 0 !important;
    border: none;
  }
}
.main-txt {
  font-size: 20px;
  font-weight: 700;
}
.sub-txt {
  font-size: 18px;
}
.orbit {
  width: 100%;
  height: 65%;
  position: relative;
  &:focus {
    outline: none !important;
    outline-width: 0 !important;

    border: none;
  }
  .userInput {
    &:focus {
      outline: none !important;
      outline-width: 0 !important;
      border: none;
    }
  }
}
.carousel-3d-container {
  // width: 50vw !important;
  height: 100vh !important;
  padding-top: 50px;
  // max-height: 812px ;
  margin: unset !important;
  @media only screen and (max-width: 600px) {
    padding-top: 72px;
  }
  @media only screen and (max-height: 1000px) {
    padding-top: 10px;
  }
  // @media (orientation: landscape) {
  //   transform: rotateZ(-90deg);

  // }
  .current {
  }
  .carousel-3d-slide {
    min-height: 302px;

    height: 80vh !important;
    padding: 20px;
    max-height: 812px;
    @media only screen and (max-height: 1000px) {
      margin-top: 25px;
      height: 88vh !important;
      max-height: 100vh !important;
    }
    background: transparent linear-gradient(180deg, #ffffff7e 0%, #efeff488 30%)
      0% 0% no-repeat padding-box;
    box-shadow: 5px 5px 5px #00000033;
    backdrop-filter: blur(20px);
    border-radius: 20px;
    border: unset;
    .inner-wrap {
      height: 100%;
    }
    .selection-wrap {
      padding-left: 45px;
    }
    .title {
      font-size: 22px;
    }
  }
}
.mobile {
  .carousel-3d-slide {
    padding-bottom: 30px;
    margin-top: 0px;
    height: 84vh !important;
  }
  .selection-wrap {
    @media only screen and (orientation: landscape) and (max-height: 1023px) and (max-height: 530px) {
      display: flex;
      overflow-x: scroll;
      .memory {
        display: flex;
      }
    }
  }
}

.device-only-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  .device-only {
    width: 100%;
    border: unset;
    height: 50px;
    font-size: 18px;
    color: #6a6a6a;
    font-family: FS Elliot Light;
    // margin: 0 auto;
  }
}
.the-plan-txt {
  font-size: 70px;
  text-align: center;
  margin-bottom: 50px;
  margin-top: 28px;
  @media only screen and (max-height: 680px) {
    margin-bottom: 10px;
  }
  .left-wrap {
    position: relative;
    color: var(--dark-blue);
    .choose {
      font-size: 32px;
      font-weight: bold;
      position: absolute;
      top: -20px;
      @media only screen and (max-width: 600px) {
        font-size: 23px;
      }
    }
    .your {
      font-size: 70px;
      font-weight: normal;
      @media only screen and (max-height: 1023px) and (max-height: 530px) {
        font-size: 53px;
      }
    }
  }
  .heavy.plan {
    color: var(--pink);
  }
}
.mobile {
  .the-plan-txt {
    @media (orientation: landscape) and (max-height: 1023px) and (max-height: 530px) {
      margin-bottom: 10px;
      font-size: 40px;
      margin-top: 10px;
    }
    .choose {
      @media only screen and (max-height: 1023px) and (max-height: 767px) {
        font-size: 30px;
        @media (orientation: landscape) {
          font-size: 20px;
        }
      }
    }
    .your {
      font-size: 40px;
    }
    .heavy.plan {
      @media only screen and (max-height: 1023px) and (max-height: 767px) {
        font-size: 30px;
      }
      // @media only screen and (max-width: 600px) {
      //   font-size: 53px;
      // }
      // @media only screen and (max-height: 800px) {
      //   margin-bottom: 25px;
      // }
    }
  }
}
.plans-tags {
  overflow: hidden;
  display: flex;
  // justify-content: center;
  width: 100%;
  position: relative;
  margin-bottom: 57px;
  @media only screen and (max-height: 800px) {
    margin-bottom: 20px;
  }
  .tag {
    position: relative;
    font-size: 59px;
    color: #ffffff;
    background-image: url("/img/plan.svg");
    background-repeat: no-repeat;
    background-position: center;
    padding-left: 100px;
    width: 270px;
    height: 232px;
    .price {
      position: absolute;
      bottom: 50px;
      left: 120px;
    }
  }
}
.mobile {
  @media (orientation: landscape) and (max-height: 1023px) and (max-height: 530px) {
    .tags-details-wrap {
      position: relative;
      bottom: 70px;
      transform: scale(0.8, 0.6);
    }
    .inner-wrap {
      height: 100% !important;
    }
  }
  .plan-tags {
    @media (orientation: landscape) and (max-height: 1023px) and (max-height: 530px) {
      margin-bottom: 5px;
    }
  }
  .tag {
    width: 190px;
    height: 191px;
    padding: 20px 0px;
    padding-left: 90px;
    .price {
      left: 70px;
      bottom: 70px;
      font-size: 40px;
    }
  }
}
.big-btn-wrap {
  display: flex;
  justify-content: center;
  margin-top: 80px;
  @media only screen and (max-height: 1000px) {
    margin-top: 30px;
  }
  .select-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    width: 270px;
    height: 80px;
    @media only screen and (max-height: 1000px) {
      width: 200px;
      height: 70px;
    }
    @media only screen and (max-height: 680px) {
      height: 50px;
    }
    background: var(--dark-blue) 0% 0% no-repeat padding-box;
    border-radius: 40px;
    font-size: 24px;
    color: #ffffff;
    border: unset;
    position: relative;
    .hover-effect-big-btn {
      position: absolute;
      width: inherit;
      height: inherit;
      transform: scale(0.93, 0.8);
      border-radius: 43px;
      background: transparent;
      border: 5px solid white !important;
      display: none;
    }
    &:hover {
      .hover-effect-big-btn {
        display: block;
      }
      opacity: 0.8;
    }
    &.disabled {
      cursor: not-allowed;
      background: gray;

      opacity: 0.8;
      &:hover {
        .hover-effect-big-btn {
          display: none;
        }
        opacity: 0.8;
      }
    }
  }
}
.mobile {
  .big-btn-wrap {
    @media (orientation: landscape) {
      margin-top: 20px;
    }
    a {
      @media only screen and (max-width: 600px) {
        width: 225px;
        height: 67px;
      }
      @media (orientation: landscape) {
        width: 180px;
        height: 40px;
      }
    }
  }
}

.details-slide {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 40px;
  a {
    font-size: 18px;
    color: var(--dark-blue);
    position: relative;
    top: 5px;
  }
}

.selected-details {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  // @media only screen and (max-height: 1100px) {
  //   top: 70%;
  // }
  text-align: left;
  width: 100%;
  height: 100%;
  max-width: 1027px;
  max-height: 320px;

  background-image: url("https://media.in3d-store.com/media/img/selectedShapeMan.png");
  background-position: 10% 80%; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  box-shadow: inset 300px 0 200px #0000002f;
  .close-btn {
    top: 0px;
    right: 0px;
    // display: none;
  }
  .inner-wrap {
    margin: 20px 40px;
  }
  .header-txt {
    font-weight: 500;
    color: white;
    margin-bottom: 12px;
  }
  .name {
    width: 122px;
    display: inline-block;
  }
  .details-wrap {
    margin-top: 17px;
    margin-left: 25px;
    .circle-color {
      width: 27px;
      height: 27px;
    }

    .detail-wrap {
      color: white;
      display: flex;
      margin-bottom: 13px;
      font-size: 22px;
      .icon-wrap {
        width: 40px;
        height: 30px;
        &.plan {
          position: relative;
          right: 6px;
          margin: 0;
          img {
            width: 40px;
          }
        }
        img {
          width: 25px;
          height: 25px;
          // margin-right: 10px;
        }
      }
    }
  }
}
.nextstep-btns {
  display: flex !important;
  a {
    // -webkit-appearance: button;
    // -moz-appearance: button;
    // appearance: button;
    .btn {
      width: 220px;
    }
  }
  .btn {
    cursor: pointer;
    text-align: center;
    margin: 0;
    padding: 0;
    text-decoration: none;
    width: 100%;
    // line-height: 32px;
    max-width: 210px;
    // height: 40px;
    // font-weight: 500;
    // letter-spacing: 1px;
    // max-height: 40px;
    background-color: #ffffff;
    border: 2px solid #3966aa;
    border-radius: 86px !important;
    color: #3966aa;
    font-size: 18px;
    margin-right: 20px;
    position: relative;
    &:hover {
      opacity: 0.8;
    }
  }
  @media (orientation: portrait) {
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .btn {
      margin-right: 0;
      margin-bottom: 10px;
      margin-right: unset;
    }
  }
}
.plan-details {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  // @media only screen and (max-height: 1100px) {
  //   top: 70%;
  // }
  text-align: left;
  width: 100%;
  height: 100%;
  max-width: 1027px;
  max-height: 320px;

  background-image: url("https://media.in3d-store.com/media/img/plan_details.png");
  background-position: 10% 80%; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
  box-shadow: inset 300px 0 200px #0000002f;
  .close-btn {
    top: 0px;
    right: 0px;
    // display: none;
  }
  .inner-wrap {
    margin: 30px 50px;
  }
  .plan-logo {
    font-size: 23px;
    color: white;
  }
  .details-wrap {
    margin-top: 17px;
    margin-left: 50px;

    .detail-wrap {
      color: white;
      display: flex;
      margin-bottom: 7px;
      font-size: 18px;
      .icon-wrap {
        width: 48px;
        img {
          // margin-right: 10px;
        }
      }
    }
  }
}
.mobile {
  .selected-details {
    @media (orientation: portrait) {
      display: none;
    }
    transform: scaleY(0.76) scaleX(0.67);
    width: 160%;

    top: -10%;
    left: -22%;
    // @media only screen and (min-height: 769px) {
    //   width: 100%;
    //   left: 42%;
    //   top: 50%;
    //   transform: scale(0.8) translate(-50%, -50%);
    // }
    @media only screen and (min-height: 470px) {
      // normal ipad
      width: 100%;
      left: 42%;
      top: 42%;
      transform: scale(0.8) translate(-50%, -50%);
    }
    .close-btn {
      // display: none;
      position: absolute;
      top: 0;
      right: 50px !important;
      img {
        width: 95px !important;
        height: 70px !important;
      }
    }
  }
}
.selected-details-mobile {
  display: none;
}
.mobile {
  .selected-details-mobile {
    @media (orientation: portrait) {
      display: block;
      border-radius: 16px;
      background: #3966aa;
      padding: 0 10px;

      width: 313px;
      position: absolute;
      left: 50%;
      top: 46%;
      transform: translate(-50%, -50%);
      height: 87vh;
      max-height: 600px;
      .close-btn {
        // display: none;
        position: absolute;
        top: 0;
        right: -30px !important;
        img {
          width: 60px !important;
          height: 60px !important;
        }
      }
      img {
        position: relative;
        top: -10px;
        left: -10px;
        width: 341px;
        height: 240px;
        margin-right: auto;
      }
      .name {
        width: 80px;
        display: inline-block;
      }
      .details-wrap {
        margin-top: 0px;
        margin-left: 5px;
        padding-left: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        position: relative;
        // overflow-y: scroll;
        .circle-color {
          position: relative;
          right: 10px;
          width: 22px;
          height: 22px;
        }
        .detail-wrap {
          display: flex;
          align-items: center;
          // align-items: flex-start;
          color: white;
          margin-bottom: 20px;
          font-size: 18px;
          text-align: left;
          .icon-wrap {
            width: 30px;
            height: 30px;
            &.plan {
              position: relative;
              top: -5px;
              margin: 0;
              img {
                top: 7px;
                right: 6px;
                width: 30px;
              }
            }
            img {
              position: relative;
              top: 4px;
              width: 20px;
              height: 20px;
              // margin-right: 10px;
            }
          }
        }
      }
    }
  }
}

.plan-details-mobile {
  border-radius: 16px;
  background: #3966aa;
  padding: 0 10px;
  width: 313px;
  height: 90vh;
  max-height: 810px;

  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  @media (orientation: landscape) {
    @media only screen and (min-height: 470px) {
      height: 370px;
    }
    height: 225px;
    width: 90vw;
    display: flex;
    max-width: 871px;
  }

  @media only screen and (max-height: 400px) {
    top: 10%;
    transform: translateX(-50%);
  }
  .close-btn {
    position: absolute;
    top: -25px;
    right: -30px !important;
    img {
      width: 60px !important;
      height: 60px !important;
    }
  }
  .mobile-vd-img {
    position: relative;
    width: 341px;
    height: 240px;
    margin-right: auto;
    @media (orientation: landscape) {
      left: -10px;
      width: 251px;
      height: 160px;
    }
  }
  .details-wrap {
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 5px;
    min-width: 300px;
    padding: 20px;
    position: relative;
    overflow-y: scroll;
    height: 300px;
    @media only screen and (max-height: 800px) {
      height: 200px !important;
    }
    @media (orientation: landscape) {
      max-width: 420px;
      height: 140px !important;
      @media only screen and (min-height: 470px) {
        height: 295px !important;
      }
    }
    .detail-wrap {
      display: flex;
      align-items: flex-start;
      color: white;
      margin-bottom: 20px;
      font-size: 18px;
      text-align: left;
      .icon-wrap {
        position: relative;
        // width: 48px;
        // display: flex;
        width: 30px;
        height: 20px;
        // align-items: center;
        img {
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 20px;
          height: 20px;
        }
      }
    }
  }
}
.details-btn {
  position: relative;
  border: none;
  background: none;
  text-decoration: underline;
  font-size: 15px;
  color: #48728c;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
}
.colors {
  display: flex;
  margin-bottom: 10px;
}
.circle-color {
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  display: flex;
  align-items: center;
  &.check {
    background-repeat: no-repeat;
    background-position: center;
    background-image: url("https://media.in3d-store.com/media/icons/check.svg");
    &.white {
      background-repeat: no-repeat;
      background-position: center;
      background-image: url("https://media.in3d-store.com/media/icons/check_black.svg");
    }
    // width: 120%;
    // height: 120%;
  }
}

.memory {
  .btn-memory {
    margin-right: 10px;
    width: 80px;
    height: 30px;
    // background: transparent
    //   radial-gradient(closest-side at 49% 27%, #ffffff99 0%,  var(--dark-blue) 100%);
    color: var(--dark-blue);
    border: 2px solid var(--dark-blue);
    border-radius: 20px;
    &:hover:not(.selected) {
      font-weight: 700;
      background: transparent
        linear-gradient(180deg, #ffffff80 0%, #429ee057 100%) 0% 0% no-repeat
        padding-box;
      // &:after {
      //   content: "";
      //   position: absolute;
      //   width: 94%;
      //   height: 80%;
      //   border: 4px solid white;
      //   border-radius: 40px;
      // }
    }
    &:active:not(.selected) {
      font-weight: 700;
      background: unset;
    }
  }
  .selected {
    background-color: var(--dark-blue);
    color: white;
  }
}
.btn-spec {
  cursor: pointer;
  width: 120px;
  height: 40px;
  border-radius: 13px;
  color: var(--dark-blue);
  border: 2px solid var(--dark-blue);
  border-radius: 20px;
  font-weight: 600;
  position: relative;
  &:first-of-type {
    margin-right: 10px;
  }
  &:hover {
    background: var(--dark-blue);
    color: white;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 95%;
      height: 82%;
      border: 3px solid white;
      border-radius: 40px;
    }
  }
  &.selected {
    background: var(--dark-blue);
    color: white;
  }
}
.mobile {
  .btn-spec {
    // width: 80px;
    height: 30px;
  }
}

.phone-details {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 5;
  background-color: rgba(255, 255, 255, 0);
}
.view-details {
  width: 120px;
  height: 40px;
  border-radius: 20px;
  color: var(--dark-blue);
  border: 2px solid var(--dark-blue);
  background: white;
  position: relative;
  top: 4px;
}
.floating-globe {
  position: absolute;
  // width: 166px;
  // height: 594px;
  // font-size: 180px;
  right: -19vh;
  font-weight: 600;
  bottom: 190px;
  transform: rotate(-90deg);
  width: 50vh;
  color: #233a8862;
  // opacity: 0.2;
  z-index: -1;
}
.wrap {
  display: flex;
  align-items: center;
  height: 100%;
  // transform: rotateZ(90deg);
}
.init-swipe-hand {
  position: absolute;
  width: 40px;
  z-index: 20;
  top: 70%;
  right: -20px;
  // position: absolute;
  // top: 92%;
  // right: 42%;
  color: white;
  font-weight: 600;
  text-shadow: 3px 2px 4px black;
  .right {
    position: absolute;
    top: 15px;
    right: 0px;
    animation: right 6s;
  }
  p {
    // background-color: white;
    position: relative;
    right: 120px;
    top: -15px;
    width: 150px;
  }
}

.mobile {
  //erase
  .carousel-3d-slide {
    overflow: unset;
  }
}
@keyframes right {
  0% {
    right: 20px;
  }
  25% {
    right: -20px;
  }
  50% {
    right: 20px;
  }
  75% {
    right: -20px;
  }
  100% {
    right: 0;
  }
}
// @keyframes right {
//   0% {
//     right: 12px;
//   }
//   25% {
//     right: -12px;
//   }
//   50% {
//     right: 12px;
//   }
//   75% {
//     right: -12px;
//   }
//   100% {
//     // display: none;
//     right: 0;
//   }
// }

.specs-wrap {
  height: 100%;
  max-height: 400px;
  overflow-y: auto;
}
.mobile {
  .specs-wrap {
    @media only screen and (max-height: 1023px) and (max-width: 767px) {
      overflow-y: scroll;
    }
    // @media (orientation: landscape) {
    //   @media only screen and (max-width: 470px) {
    //     height: 170px !important;
    //   }
    // }
    @media (orientation: landscape) {
      @media only screen and (max-height: 470px) {
        height: 170px;
      }
    }
  }
}
.phone-name {
  margin: 0;
  color: var(--dark-blue);
  font-weight: 500;
}
.mobile {
  .phone-name {
    @media (orientation: landscape) {
      font-size: 20px;
    }
  }
}
.card-name {
  color: var(--dark-blue);
  font-family: FS Elliot Light;
  font-size: 20px;
  margin-bottom: 30px;
}
.out-of-stock {
  color: #c73069;
}
.mobile {
  .card-name {
    margin-bottom: 5px;
    @media (orientation: landscape) {
      font-size: 15px;
    }
    &.phone-slide {
      margin-bottom: 5px;
      @media (orientation: landscape) {
        margin-bottom: 0px;
        font-size: 5px;
      }
    }
  }
}
.toggle-plan {
  font-family: "Lucida Sans", "Lucida Sans Regular", "Lucida Grande",
    "Lucida Sans Unicode", Geneva, Verdana, sans-serif;
  display: flex;
  align-items: center;
  padding: 0;
  font-weight: 900;
  font-size: 50px;
  transform: scaleY(1.5);
  line-height: 38px;
  border: unset;
  background: unset;
  color: white;
  text-shadow: 2px 2px 4px #00000077;
  @media only screen and (max-height: 800px) {
    font-size: 35px;
  }
}
.btn-wrap {
  text-align: center;
  margin-bottom: 43px;
}
.mobile {
  .btn-wrap {
    margin-bottom: 15px;
  }
}
.spec {
  border-bottom: 1px solid #707070;
  &.no-border {
    border-bottom: unset;
  }
  .inner-wrap {
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    .icon-wrap {
      max-width: 60px;
      width: 100%;
    }
    .icon {
      &.battery {
        left: 45px;
        width: 22px;
        align-self: flex-start;
      }
      &.camera {
        width: 23px;
        height: 20px;
      }
      &.screen {
        width: 17px;
        height: 24px;
      }
      &.memory {
        width: 20px;
        height: 20px;
      }
      &.chipset {
        width: 20px;
        height: 20px;
      }
      &.ram {
        width: 19px;
        height: 20px;
      }
      &.front {
        width: 24px;
        height: 20px;
      }
      &.sim {
        width: 15px;
        height: 20px;
      }
      &.ios {
        width: 15px;
        height: 24px;
      }
      &.android {
        width: 20px;
        height: 11px;
      }
    }
  }
}

.orbit-view {
  height: 100px;
  width: 100px;
}
.close-btn {
  // z-index: 234;
}
.mobile {
  .phone-details {
    .outer-ui {
      img {
        width: 70px;
      }
    }
  }
}
.loader {
  position: absolute;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
  z-index: 5;
}
.init360 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  width: 80px;
  pointer-events: none;
  // height: 50px;
}
.mvDebug {
  z-index: 12;
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100px;
  background-color: white;
  padding: 4px;
}
</style>
